<template>
  <div id="rename-modal" class="editor-modal">
    <h2>{{ title }}</h2>
    <!-- <form @submit.stop.prevent> -->
    <form @submit="onDuplicate">
      <custom-input
        class="template-name"
        :inputType="'text'"
        v-model="newInfo.newName"
        :name="'nameInput'"
        :label="inputName"
        :placeholder="inputPlaceholder || $t('enter-name')"
        :focusInputField="true"
      />
      <div v-if="duplicateError" class="small text-danger">{{ $t("template.duplicate-error") }}</div>
      <div class="form-group">
        <label for="existing">{{ $t("template.cr-tp-lang-label") }}</label>
        <select class="form-control selector" id="languageInput" v-model="newInfo.newLanguage">
          <option class="default" :value="existingLang">{{ existingLangPretty() }}</option>
          <option v-for="(language, index) in templateLanguages" :key="index" :value="language.value">
            {{ $t(language.name) }}
          </option>
        </select>
      </div>
      <div class="footer">
        <button type="submit" class="btn btn-md btn-primary" :disabled="!valid" @click="onDuplicate">
          {{ primaryButton }}
        </button>
        <button type="reset" class="btn btn-md btn-secondary" @click="onClose">
          {{ $t("rename.rename-btn-cancel") }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import CustomInput from "@/components/CustomInput";
export default {
  props: {
    existingName: String,
    onSave: Function,
    inputName: String,
    inputPlaceholder: String,
    title: String,
    primaryButton: String,
    existingLang: String
  },
  data() {
    return {
      newInfo: {
        newName: "",
        newLanguage: null
      },
      duplicateError: false
    };
  },
  computed: {
    valid() {
      return this.newInfo.newName && this.newInfo.newLanguage;
    },
    templateLanguages() {
      return this.$store.state.templateLanguages.filter((l) => l.value !== this.existingLang.toLowerCase());
    }
  },
  methods: {
    onDuplicate(evt) {
      evt.preventDefault();

      let findDuplicate = this.$store.state.templates.find((d) => d.name === this.newInfo.newName);
      if (findDuplicate) {
        this.duplicateError = true;
      } else {
        this.onSave(this.newInfo);
        this.$emit("close");
      }
    },
    onClose(evt) {
      this.$emit("close");
    },
    existingLangPretty() {
      const lang = this.$store.state.templateLanguages.find((l) => l.value == this.existingLang.toLowerCase());
      return lang ? this.$t(lang.name) : "";
    }
  },

  mounted() {
    // this.$refs.name.focus()
  },
  watch: {
    existingName: {
      immediate: true,
      handler(name) {
        if (name) this.newInfo.newName = name + " (copy)";
      }
    },
    existingLang: {
      immediate: true,
      handler(lang) {
        if (lang) this.newInfo.newLanguage = lang;
      }
    }
  },
  components: {
    CustomInput
  }
};
</script>

<style lang="less">
#rename-modal {
  padding: 30px 25px 25px 25px;
  h2 {
    margin: 0;
  }
  .template-name {
    margin-bottom: 16px;
  }
  .footer {
    margin-top: 40px;
  }
}
</style>
